import { render, staticRenderFns } from "./CoEvaluatorRubric.vue?vue&type=template&id=4201a4ee&scoped=true"
import script from "./CoEvaluatorRubric.vue?vue&type=script&lang=js"
export * from "./CoEvaluatorRubric.vue?vue&type=script&lang=js"
import style0 from "./CoEvaluatorRubric.vue?vue&type=style&index=0&id=4201a4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4201a4ee",
  null
  
)

export default component.exports